// src/components/TourFab.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTour } from '@reactour/tour';
import { matchSteps } from '../tutorial/steps-registry';

export default function TourFab(){
    const loc = useLocation();
    const { setIsOpen, setSteps, setCurrentStep } = useTour();

    const raw = matchSteps(loc.pathname) || [];
    if (!raw.length) return null;

    const exists = (sel) => !sel || !!document.querySelector(sel);
    const live = raw.filter(s => exists(s.selector));
    const steps = live.length ? live : [{ content: 'Samouczek: brak elementów do podświetlenia (sprawdź selektory).' }];

    return (
        <button
            aria-label="Samouczek"
            onClick={() => { setSteps(steps); setCurrentStep(0); setIsOpen(true); }}
            style={{
                position:'fixed', right:20, bottom:20, zIndex: 100002,
                width:56, height:56, borderRadius:'50%', border:'none',
                cursor:'pointer', background:'linear-gradient(135deg,#111,#333)',
                color:'#fff', boxShadow:'0 8px 24px rgba(0,0,0,.25)'
            }}
            title="Uruchom samouczek"
        >
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.6" opacity="0.6"/>
                <path d="M12 7.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm-1.2 4.2c0-.44.36-.8.8-.8h.8c.44 0 .8.36.8.8v4.8c0 .44-.36.8-.8.8h-.8a.8.8 0 0 1-.8-.8v-4.8Z" fill="currentColor"/>
            </svg>
        </button>
    );
}
